import { useEffect, useState } from 'react';
import './App.css';
import SolutionsPage from './pages/SolutionsPage';
import { getSavedSolutions } from './data/solutions';


function App() {
  const [activePage, setActivePage] = useState('accueil');

  const goHome = () => setActivePage('accueil');

  const [solutions, setSolutions] = useState(getSavedSolutions);

  useEffect(() => {
    localStorage.setItem('tanga-solutions', JSON.stringify(solutions));
  }, [solutions]);

  return (
    <div className="app">
      <header className="site-header">
        <button
          type="button"
          className="brand"
          onClick={goHome}
          aria-label="Retour à l'accueil"
        >
          <img
            src="/tanga_app_logo_simple.png"
            alt="Logo Tanga Africa"
            className="brand-logo"
          />
          <span className="brand-copy">
            <strong>TANGA AFRICA</strong>
            <span>Digital workspace</span>
          </span>
        </button>

        <div className="header-status">
          <span className="status-dot" />
          Portail interne
        </div>
      </header>

      <main className="main-content">
        {activePage === 'accueil' && (
          <>
            <section className="hero">
              <div className="hero-content">
                <span className="eyebrow">
                  VOTRE ESPACE DIGITAL
                </span>

                <h1>
                  Tout votre univers digital,
                  <span> au même endroit.</span>
                </h1>

                <p>
                  Bienvenue sur le portail Tanga Africa.
                  Retrouvez vos plateformes et gérez vos solutions
                  depuis un espace unique, simple et intuitif.
                </p>

                <button
                  type="button"
                  className="hero-button"
                  onClick={() => setActivePage('solutions')}
                >
                  Découvrir les solutions
                  <span aria-hidden="true">→</span>
                </button>
              </div>

              <div className="hero-art" aria-hidden="true">
                <div className="orbit orbit-one" />
                <div className="orbit orbit-two" />
                <div className="hero-glow" />
                <div className="hero-monogram">T</div>
                <div className="floating-chip chip-one">Digital</div>
                <div className="floating-chip chip-two">Africa</div>
              </div>

              <div className="hero-decoration" />
            </section>



            <section className="platform-section">
              <div className="section-heading">
                <div>
                  <span className="section-kicker">VOS PLATEFORMES</span>
                  <h2>Les solutions Tanga Africa</h2>
                  <p>Accédez rapidement à vos outils numériques.</p>
                </div>

                <button
                  type="button"
                  className="text-button"
                  onClick={() => setActivePage('solutions')}
                >
                  Voir toutes les solutions →
                </button>
              </div>


              <div className="platform-grid">
                {solutions.map((solution) => (
                  <a
                    key={solution.id}
                    className="platform-card"
                    href={solution.url || undefined}
                    target={solution.url ? '_blank' : undefined}
                    rel={solution.url ? 'noopener noreferrer' : undefined}
                    onClick={(event) => {
                      if (!solution.url) event.preventDefault();
                    }}
                  >
                    <span className="platform-icon platform-blue">▥</span>

                    <span className="platform-info">
                      <strong>{solution.name}</strong>
                      <span>{solution.description}</span>
                    </span>

                    <span className="external-arrow">↗</span>
                  </a>
                ))}
              </div>

            </section>
          </>
        )}

        {activePage !== 'accueil' && (
          <section className="inner-page">
            <button
              type="button"
              className="back-button"
              onClick={goHome}
            >
              <span aria-hidden="true">←</span>
              Retour à l'accueil
            </button>



            {activePage === 'solutions' && (
              <SolutionsPage
                solutions={solutions}
                setSolutions={setSolutions}
              />
            )}
            {activePage === 'gestion' && (
              <section className="management-panel">
                <div className="management-icon">↗</div>
                <h2>Gestion centralisée des liens</h2>
                <p>
                  Retrouvez les plateformes de Tanga Africa et accédez
                  à la rubrique Solutions digitales pour consulter
                  ou modifier les liens disponibles.
                </p>

                <button
                  type="button"
                  className="hero-button"
                  onClick={() => setActivePage('solutions')}
                >
                  Gérer les solutions
                  <span aria-hidden="true">→</span>
                </button>
              </section>
            )}
          </section>
        )}

        <footer className="site-footer">
          <span className="footer-brand">TANGA AFRICA</span>
          <span>© 2026 · Portail digital interne</span>
        </footer>
      </main>
    </div>
  );
}

export default App;